<div [chart]="precipitationHourlyChart"></div>
